import { Toast } from 'vant'
// import { formatBytes } from '@/utils'
import EXIF from '@/utils/exif'

export const M = 1024 * 1024
export const COMPRESS_IMAGE_MIN_SIZE = 2 * M // 2M，单位 byte 最小的压缩条件
// export const COMPRESS_IMAGE_MAX_SIZE = 40 * M // 40M，单位 byte 最大的压缩条件
export const COMPRESS_IMAGE_MAX_SIZE = 10 * M // 10M，单位 byte 最大的压缩条件（产品限制上传10M）

export const UPLOAD_MAX_M = 20 // 上传最大的大小，单位 M
export const UPLOAD_MAX_SIZE = UPLOAD_MAX_M * M // 10M，单位 byte
export const UPLOAD_MAX_COUNT = 1 // 文件上传数量限制
export const UPLOAD_ACCEPT_TYPE_IMAGE = ['image/png', 'image/jpeg', 'image/bmp', 'image/gif']
// 上传图片文件后缀限制
export const UPLOAD_ACCEPT_TYPE_IMAGE_SUFFIX = ['bmp', 'gif', 'jpg', 'pic', 'png', 'tif', 'jpg', 'jpeg', 'tiff', 'jpe', 'pjp', 'jxr', 'avif', 'mng', 'pjpeg', 'svg', 'webp']
export const UPLOAD_ACCEPT_TYPE_VIDEO = ['video/mp4', 'video/quicktime']
// 上传视频文件后缀限制
export const UPLOAD_ACCEPT_TYPE_VIDEO_SUFFIX = ['avi', 'mpg', 'mov', 'swf', 'mp4', 'mov', 'wmv']
export const UPLOAD_ACCEPT_TYPE_FILE = []
// 上传文件后缀限制
export const UPLOAD_ACCEPT_TYPE_FILE_SUFFIX = ['txt', 'doc', 'hlp', 'wps', 'rtf', 'html', 'pdf', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']
// 上传文件音频后缀限制
export const UPLOAD_ACCEPT_TYPE_AUDIO_SUFFIX = ['wav', 'aif', 'au', 'mp3', 'ram', 'wma', 'mmf', 'amr', 'aac', 'flac', 'rmi', 'mid', 'rm']

/**
 * @param { String } type
 * @param { Array } acceptType - 可接受的文件类型
 * @returns { Boolean }
 */
export function isValidFileType (type, acceptType) {
    if (acceptType.length === 0) {
        return true
    }
    return acceptType.includes(type)
}

/**
 * @param { String } filename
 * @returns { String }
 */
export function getFileSuffix (filename) {
    return filename.split('.').pop()
}

/**
 * @param { File } type - file
 * @param { Number } size - Bytes
 * @returns { String } 空字符传代表检验通过，否则校验不通过
 */
export function isValidFileSize (file, size) {
    let result = ''
    let resultInfo = ''
    if (UPLOAD_ACCEPT_TYPE_IMAGE_SUFFIX.includes(getFileSuffix(file.name))) {
        result = size <= COMPRESS_IMAGE_MAX_SIZE ? '' : COMPRESS_IMAGE_MAX_SIZE
        resultInfo = '图片大小限制10M以内'
    } else {
        result = size <= UPLOAD_MAX_SIZE ? '' : UPLOAD_MAX_SIZE
        resultInfo = `请上传小于${UPLOAD_MAX_M}M的文件`
    }

    return result
        // ? `请上传小于${formatBytes(result)}的文件`
        ? resultInfo
        : ''
}

/**
 * @param { File } file - 图片文件
 * @returns { File | Boolean } 非合法图片类型 / 超过 40 M，返回 false
 */
export function compressImage (file) {
    const fileName = file.name
    const fileType = file.type
    const fileSize = file.size
    // 非图片不处理
    if (!isValidFileType(getFileSuffix(fileName), UPLOAD_ACCEPT_TYPE_IMAGE_SUFFIX)) {
        Toast.fail('请选择图片')
        return false
    }

    // 大于 40M 禁止上传
    // if (fileSize > COMPRESS_IMAGE_MAX_SIZE) {
    //     Toast.fail('请上传小于40M的图片')
    //     return false
    // }
    // 大于 10M 禁止上传
    if (fileSize > COMPRESS_IMAGE_MAX_SIZE) {
        Toast.fail('请上传小于10M的图片')
        return false
    }

    // 图片小于或等于 2M 不处理
    if (fileSize <= COMPRESS_IMAGE_MIN_SIZE) {
        return file
    }

    let orientation = null
    try {
        EXIF.getData(file, function () {
            orientation = EXIF.getTag(this, 'Orientation')
        })
    } catch (err) {
        // eslint-disable-next-line
        console.error(err)
    }

    Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在压缩图片'
    })

    const compressStartTime = Date.now()
    const reader = new FileReader()

    return new Promise((resolve, reject) => {
        reader.onload = async () => {
            try {
                const blob = await canvasDataURL(reader.result)
                const file = new File([blob], fileName, {
                    type: fileType
                })
                return resolve(file)
            } catch (err) {
                return reject(err)
            }

        }
        reader.readAsDataURL(file)
    })

    function canvasDataURL (path) {
        // const img = new Image()
        const img = document.createElement('img')
        if ('imageOrientation' in img.style) {
            // 浏览器本身支持根据Exif信息正确显示图片的，此处不再旋转图片
            console.log('imageOrientation is support')
            orientation = 1
        }
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        return new Promise((resolve) => {
            img.onload = () => {
                const zoom = Math.floor(Math.max(img.width, img.height) / 1500)
                canvas.width = zoom > 1 ? img.width / zoom : img.width
                canvas.height = zoom > 1 ? img.height / zoom : img.height

                const imgWidth = canvas.width
                const imgHeight = canvas.height

                if (orientation && orientation != 1) {
                    switch(orientation) {
                        case 6:     // 旋转90度
                            canvas.width = imgHeight
                            canvas.height = imgWidth
                            ctx.rotate(Math.PI / 2)
                            // (0,-imgHeight) 从旋转原理图那里获得的起始点
                            ctx.drawImage(img, 0, -imgHeight, imgWidth, imgHeight)
                            break
                        case 3:     // 旋转180度
                            ctx.rotate(Math.PI)
                            ctx.drawImage(img, -imgWidth, -imgHeight, imgWidth, imgHeight)
                            break
                        case 8:     // 旋转-90度
                            canvas.width = imgHeight
                            canvas.height = imgWidth
                            ctx.rotate(3 * Math.PI / 2)
                            ctx.drawImage(img, -imgWidth, 0, imgWidth, imgHeight)
                            break
                    }
                } else {
                    ctx.drawImage(img, 0, 0, imgWidth, imgHeight)
                }
                if (!HTMLCanvasElement.prototype.toBlob) {
                    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
                        value: function (callback, type, quality) {
                            let binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
                                len = binStr.length,
                                arr = new Uint8Array(len)
                            for (let i=0; i<len; i++ ) {
                                arr[i] = binStr.charCodeAt(i)
                            }
                            callback( new Blob( [arr], {type: type || 'image/png'} ) )
                        }
                    })
                }
                canvas.toBlob(blob => {
                    const duration = Date.now() - compressStartTime
                    setTimeout(() => {
                        Toast.clear()
                        return resolve(blob)
                    }, Math.max((1500 - duration), 10))
                }, file.type, 0.1)
            }
            img.src = path
        })
    }
}
